<template>
  <div class="login-page">
    <el-card class="login-card">
      <div slot="header" class="login-title">
        二手交易后台管理系统
      </div>
      <el-form :model="form" :rules="rules" ref="loginForm" label-width="80px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="form.username" autocomplete="off" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" autocomplete="off" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="handleLogin" style="width: 100%">登 录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import http from '@/utils/http'

export default {
  name: 'LoginPage',
  data () {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid || this.loading) return
        this.loading = true
        try {
          const res = await http.post('/api/admin/login', {
            username: this.form.username,
            password: this.form.password
          })

          // 兼容不同返回字段命名
          let token = res && (res.token || res.accessToken || res.jwt)
          // 兼容多种返回结构
          let adminId = res && (res.adminId || res.id)

          // 如果接口直接返回字符串或 data 字段，视为 token/会话标记
          if (!token && typeof res === 'string' && res.trim()) {
            token = res.trim()
          }
          if (!token && res && typeof res === 'object' && typeof res.data === 'string' && res.data.trim()) {
            token = res.data.trim()
          }

          // 如果返回值或 data 是数字或数字字符串，视为 adminId
          const numericFromRes = typeof res === 'number' ? res : (typeof res === 'string' && /^\d+$/.test(res) ? Number(res) : undefined)
          const numericFromData = res && typeof res === 'object' && typeof res.data === 'number' ? res.data : undefined
          if (!adminId && numericFromRes !== undefined) {
            adminId = numericFromRes
          }
          if (!adminId && numericFromData !== undefined) {
            adminId = numericFromData
          }

          // 如果 token 含有非 ASCII 字符（如中文“登陆成功”），不用它做 header，改用占位
          const isAsciiToken = typeof token === 'string' && !/[^\u0020-\u007E]/.test(token)
          if (token && !isAsciiToken) {
            token = 'session-active'
          }

          if (!token) {
            // 如果后端使用 cookie 维持会话且未返回 token，这里使用占位标记让路由守卫放行
            token = 'session-active'
          }

          localStorage.setItem('token', token)
          // 同步存储管理员标识，后续修改密码可用；优先 adminId，其次 id，最后用户名
          if (adminId !== undefined && adminId !== null) {
            localStorage.setItem('adminId', adminId)
          } else if (this.form.username) {
            localStorage.setItem('adminId', this.form.username)
          }
          localStorage.setItem('adminUsername', this.form.username)

          this.$message.success('登录成功')
          this.$router.push('/')
        } catch (error) {
          console.error('登录失败', error)
          this.$message.error(error.message || '账号或密码错误')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f2f3f5;
}

.login-card {
  width: 380px;
}

.login-title {
  text-align: center;
  font-size: 18px;
}
</style>
